import classNames from 'classnames'
import Textfield from 'shared/components/Textfield'
import ValidationError from 'shared/components/ValidationError'

import styles from '../styles.module.scss'

const FlightInfo = ({
    bookingData,
    setOutboundNumber,
    setInboundNumber,
    outboundNumberError,
    setOutboundNumberError,
    inboundNumberError,
    setInboundNumberError,
    locationDetails,
    showSubmitErrors,
}) => {
    // A submit attempt also flags the flight numbers the customer never filled in
    const showOutboundError = outboundNumberError || (showSubmitErrors && !bookingData.outboundNumber)
    const showInboundError = inboundNumberError || (showSubmitErrors && !bookingData.inboundNumber)

    return (
        <div className={classNames('p-4 p-sm-0', styles.flightInfoSection)}>
            <h5 className="mb-5">
                <T>booking.flight.info.label</T>
            </h5>
            <div className="d-flex flex-column flex-sm-row">
                {locationDetails.isOutboundFlight && (
                    <div className="w-100 px-0">
                        <Textfield
                            name="outboundNumber"
                            value={bookingData.outboundNumber}
                            required
                            status={showOutboundError ? 'error' : undefined}
                            onChange={e => setOutboundNumber({ outboundNumber: e.currentTarget.value })}
                            label={<T>booking.outbound.flight.number.label</T>}
                            minLength={1}
                            maxLength={10}
                            setShowError={setOutboundNumberError}
                        />
                        {showOutboundError && (
                            <ValidationError>
                                <T>booking.outbound.input.invalid</T>
                            </ValidationError>
                        )}
                    </div>
                )}
                {locationDetails.isInboundFlight && (
                    <div className="w-100 mt-4 mt-sm-0 ml-sm-5">
                        <Textfield
                            name="inboundNumber"
                            className={''}
                            value={bookingData.inboundNumber}
                            onChange={e => setInboundNumber({ inboundNumber: e.currentTarget.value })}
                            label={<T>booking.inbound.flight.number.label</T>}
                            required
                            status={showInboundError ? 'error' : undefined}
                            minLength={1}
                            maxLength={10}
                            setShowError={setInboundNumberError}
                        />
                        {showInboundError && (
                            <ValidationError>
                                <T>booking.inbound.input.invalid</T>
                            </ValidationError>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default FlightInfo
